export default function () {
  if (request?.dnsSentryFrontend) {
    import(/* webpackChunkName: "sentry-track-module" */ './sentry').then(
      (module) => {
        const SentryTrack = module.default
        SentryTrack()
      }
    )
  }
}
